import { useEffect } from 'react';
import styled from 'styled-components';

import { useLocation } from '@xing-com/crate-core-router';

import { adSlotConfig } from '../../ad-slot-config';
import { useDisplayAdTracking } from '../../hooks';

const AdContainer = styled.div`
  min-height: 90px;
  max-height: 300px;
`;

const AdWrapper = styled.div`
  width: 728px;
  min-height: 90px;
  max-height: 300px;
  position: relative;
  z-index: 1;
`;

declare const YLHH: any;

export const DisplayAdLoginLeaderboardIframe: React.FC = () => {
  const { id, adUnitPath, size } = adSlotConfig.Login.LeaderboardIframe;

  const location = useLocation();
  const locationParams = new URLSearchParams(location.search);

  const sentBy = locationParams.get('sentBy') || 'undefined';
  const page = locationParams.get('page') || 'undefined';
  const { onViewableListener } = useDisplayAdTracking({ sentBy, page });

  useEffect(() => {
    window.googletag?.cmd.push(() => {
      const slot = googletag.defineSlot(adUnitPath, size, id);

      if (slot) {
        slot.addService(googletag.pubads());
        googletag.display(slot);
      }

      googletag
        .pubads()
        .addEventListener('impressionViewable', onViewableListener);
    });

    // @ts-expect-error yieldlove_cmd is defined by header bidding script
    window.yieldlove_cmd?.push(function () {
      YLHH?.bidder.startAuction(adUnitPath, undefined);
    });

    return () => {
      window.googletag?.cmd.push(() => {
        googletag
          .pubads()
          .removeEventListener('impressionViewable', onViewableListener);
      });
    };
  }, []);

  return (
    <AdWrapper>
      <AdContainer id={id} />
    </AdWrapper>
  );
};
